/**
 * @description 楽天トラベルカスタマイズページの判定
 * @returns {boolean} 楽天トラベルカスタマイズページの場合はtrue,それ以外はfalse
 */
export function isRakuten(): boolean {
  return $('#RthCustomizeW').length > 0;
}
